import React, { useEffect, useState } from 'react';
import GlyphSvg from './Glyphs';
import '../utils/upload-progress-glyphs.css';

const ROWS = 6;
const ANIMATION_DURATION = 1200; // ms per row
const RESET_DELAY = 800; // ms after complete
const ICON_SIZE = 12;

export default function UploadProgressGlyphs() {
  const [currentRow, setCurrentRow] = useState(-1);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    let timeoutId;
    let animationId;

    const animateNextRow = () => {
      if (currentRow >= ROWS - 1) {
        // Animation complete, reset after delay
        timeoutId = setTimeout(() => {
          setCurrentRow(-1);
          setIsAnimating(false);
          // Start next cycle
          timeoutId = setTimeout(() => {
            setCurrentRow(0);
            setIsAnimating(true);
          }, 100);
        }, RESET_DELAY);
        return;
      }

      // Animate to next row
      setCurrentRow(prev => prev + 1);
    };

    const startAnimation = () => {
      setCurrentRow(0);
      setIsAnimating(true);
    };

    if (!isAnimating) {
      // Start the animation cycle
      timeoutId = setTimeout(startAnimation, 500);
    } else {
      // Schedule next row animation
      timeoutId = setTimeout(animateNextRow, ANIMATION_DURATION);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (animationId) clearTimeout(animationId);
    };
  }, [currentRow, isAnimating]);

  return (
    <div className="upload-progress-glyphs-container thin-bar">
      {Array.from({ length: ROWS }).map((_, i) => {
        const isActive = i === currentRow;
        const isCompleted = i < currentRow;
        
        let leftGlyph = 'g05', rightGlyph = 'g05', barColor = 'var(--c4)';
        
        if (isCompleted) {
          leftGlyph = rightGlyph = 'g01';
          barColor = 'var(--c5)';
        } else if (isActive) {
          leftGlyph = 'g07';
          rightGlyph = 'g06';
          barColor = 'var(--c5)';
        }

        return (
          <div className="upload-row thin-bar-row upload-row-spaced" key={i}>
            <GlyphSvg glyph={leftGlyph} size={ICON_SIZE} color={barColor} />
            <div className="upload-bar-outer thin-bar-outer">
              <div
                className={`upload-bar-inner thin-bar-inner ${isActive ? 'animating' : ''}`}
                style={{
                  width: isCompleted ? '100%' : isActive ? '0%' : '0%',
                  background: barColor,
                  opacity: isActive || isCompleted ? 1 : 0.5,
                  transition: isActive ? `width ${ANIMATION_DURATION}ms linear` : 'none'
                }}
              />
            </div>
            <GlyphSvg glyph={rightGlyph} size={ICON_SIZE} color={barColor} />
          </div>
        );
      })}
    </div>
  );
} 